/* eslint-disable react-hooks/exhaustive-deps */
import './style.scss';
import React, { useEffect, useState } from 'react';
import { Table, Tag } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { Button,Input } from 'antd';
import { SearchOutlined, DeleteOutlined } from '@ant-design/icons';
import { first, startCase } from 'lodash';
import ApiService from '@services/api.service';
import moment from 'moment';
import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear'

dayjs.extend(quarterOfYear)
interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
}

interface StatValueDisplayProps {
    value: number;
    animate?: boolean;
}


const StatValueDisplay = ({ value }: StatValueDisplayProps) => {
    return <span className={value === 0 ? 'red' : ''}>{value}</span>
}

const columns: ColumnsType<DataType> = [
    {
        title: 'ID',
        width: 80,
        dataIndex: 'id',
        key: "id", 
        sorter: true, 
    },
    {
        title: 'SID',
        width: 80,
        dataIndex: 'subscriptionId',
        key: 'subscriptionId',
        sorter: true, 
    },
    {
        title: 'Name',
        width: 240,
        key: 'practiceName',
        render: (row) => (
            <div>
                <p style={{ margin: 0 }}>{row?.practiceName}</p>
            </div>
        ),
        sorter: true, 
    },
    {
        title: 'Status',
        key: 'subscriptions.status',
        render: (value) => {
            const subscription = first(value?.subscriptions) as unknown as any;
            const status = startCase(subscription?.status);

            if (status === 'Active') {
                return <Tag bordered={false} color="success">{startCase(status)}</Tag>
            } else if (status === 'Canceled') {
                return <Tag bordered={false} color="error">{startCase(status)}</Tag>
            } else {
                return <Tag bordered={false} color="blue">{startCase(status)}</Tag>
            }
        },
        sorter: true, 
    },
    {
        title: 'AAO member',
        dataIndex: 'isAaoMember',
        key:'isAaoMember',
        render: (value) => {
            if (value === true) {
                return <Tag bordered={false} color="success">Yes</Tag>
            } else {
                return <Tag bordered={false} color="error">No</Tag>
            }
        },
        sorter: true, 
    },
    {
        title: 'Department Id',
        key: 'absorbDepartmentId',
        render: (value) => <StatValueDisplay value={value?.absorbDepartmentId} />,
        sorter: true, 
    },
    {
        title: 'Amount',
        key: 'subscriptions.amount',
        render: (value) => <p>$<StatValueDisplay value={value?.subscriptions[0]?.amount} /></p>,
        sorter: true, 
    },
    {
        title: '# Active Licenses',
        key:'learnerCount',
        render: (value) => <StatValueDisplay value={value?.learnerCount} />,
        sorter: true, 
    },
    {
        title: 'Member Since',
        key:'learnerCount',
        render: (value) => moment(value?.createdAt).format('DD MMM, YYYY'),
        sorter: true, 
    },
    // {
    //     title: 'Subscription Amount',
    //     render: (value) => {
    //         return `$${value?.subscriptions?.[0]?.amount}`
    //     }
    // },
];

function MedicalPractices() {
    const [searchResults, setSearchResults] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentUser,setCurrentUser]:any = useState()
    const [sort, setSort] = useState({
        field: "practiceName",
        order: "asc", // 'ascend' or 'descend'
      });
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [searchText, setSearchText] = useState("");
    const [search, setSearch] = useState(false);
    const [total, setTotal] = useState(0);
    const [ascSort, setAcsSort] = useState(false);
    const [desSort, setDesSort] = useState(false);

    useEffect(() => {
        getActivePractices(pagination.current,pagination.pageSize,sort.field, sort.order);
    }, []);
    
    function getActivePractices(page:any, pageSize:any,sortField:any, sortOrder:any ) {
        setIsLoading(true);
        ApiService.getPractices(page,pageSize,sortField,sortOrder,searchText).then((response:any) => {
            if (response?.data) {
                setSearchResults(response.data?.data);
                setTotal(response.data.total)
                setPagination((prev) => ({
                    ...prev,
                    current: page,
                    total: response.data.total,
                  }));
            }
            setIsLoading(false); 
        }).catch((error) => {
            setIsLoading(false);
        });
    }
    useEffect(() => {
        ApiService.getProfile().then(({data}:any) => {
            setCurrentUser(data?.data?.profile)
        }).catch((error) => {
        })
     
      }, []);

      const clearSearch = () => {
        setSearchText('')
        setPagination((prev) => ({
            ...prev,
            current: 1,
          }));
      };
        useEffect(()=>{
            if(searchText==='' && search===true){
                setSearch(false)
                getActivePractices(1, pagination.pageSize,'id', 'asc');
            }
        },[searchText,search])

    const handleTableChange = (pagination:any,filters:any, sorter:any) => {
        if(sorter.column===undefined){
            setSort({ field: 'practiceName', order: 'asc' });
            getActivePractices(pagination.current, pagination.pageSize,'practiceName', 'asc');
            setDesSort(false)
            setAcsSort(false)
        }else{
            if(sorter.order==='descend'){
                if(desSort===false){
                    getActivePractices(1, pagination.pageSize,sorter.column.key,'desc');
                    setDesSort(true)
                }
                else{
                    if(sorter.column.key!==sort.field){
                        getActivePractices(1, pagination.pageSize,sorter.column.key,'desc');
                    }else{
                        getActivePractices(pagination.current, pagination.pageSize,sorter.column.key,'desc');
                    }
                }
                setSort({ field: sorter.column.key, order: sorter.order });
            }
            if(sorter.order==='ascend'){
                if(ascSort===false){
                    getActivePractices(1, pagination.pageSize,sorter.column.key,'asc');
                    setAcsSort(true)
                }
                else{
                    if(sorter.column.key!==sort.field){
                        getActivePractices(1, pagination.pageSize,sorter.column.key,'asc');
                    }else{
                        getActivePractices(pagination.current, pagination.pageSize,sorter.column.key,'asc');
                    }
                }
                setSort({ field: sorter.column.key, order: sorter.order });
            }

        }
    };
    const handleSearch = () => {
        if(searchText!==''){
        setSearch(true)
        setPagination((prev) => ({
            ...prev,
            current: 1,
          }));
          getActivePractices(1, pagination.pageSize,'id', 'asc');
        }
      };

    const roleBasedColumns:any = {
        3: columns, // Admin sees all
        4: columns.filter((col:any) => !["isAaoMember", "absorbDepartmentId"].includes(col.key)), // Editor cannot see Salary
      };
   
    return (
        <div className='practice-container'>
              <div className="section-header">
              <div className="title">
                    {total > 0 && <h2 className="section-title">({total})</h2>}
                </div>
                <div className="practice-dropdown-container" style={{textAlign:'right',margin:'10px 0'}}>
                    {/* <Select
                        loading={isLoading}
                        value={selectedDropdownValue}
                        style={{ width: 200 }}
                        onChange={handleChange}
                        fieldNames={{ label: 'practiceName', value: 'id' }}
                        options={medicalPractices}
                    /> */}
                        <Input
                        placeholder="Search..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: 200, marginRight: 8 }}
                        />
                        <Button type="primary" style={{height:"31.6px"}} icon={<SearchOutlined rev={undefined} />}  onClick={handleSearch}>Search</Button>&nbsp;&nbsp;
                        <Button onClick={clearSearch} style={{height:"31.6px"}} icon={<DeleteOutlined rev={undefined} />} >Clear</Button>&nbsp;&nbsp;
                </div>
            </div>
            <div className="table-container">
                <Table
                    bordered
                    loading={isLoading}
                    columns={roleBasedColumns[currentUser?.roleId]} 
                    dataSource={searchResults}
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: pagination.total,
                        showSizeChanger: false,
                      }}
                    scroll={{ y: 'calc(100vh - 215px)', x: 100 }}
                    onChange={handleTableChange}
                />
            </div>
        </div>
    );
}

export default MedicalPractices;